import { render } from "./AppModalWrapper.vue?vue&type=template&id=00461eb1&scoped=true"
import script from "./AppModalWrapper.vue?vue&type=script&lang=js"
export * from "./AppModalWrapper.vue?vue&type=script&lang=js"

import "./AppModalWrapper.vue?vue&type=style&index=0&id=00461eb1&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00461eb1"]])

export default __exports__